import Link from 'next/link';
import { Flex } from '@chakra-ui/layout';

import { ProfileNavbar } from './ProfileNavbar';
import { HeadLogo } from './HeadLogo';

import { NoSsr } from '@/uikit/component/NoSsr';

function PageHeader() {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      px={{ base: '1rem', md: '3rem' }}
      h={{ base: '4rem', md: '5rem' }}
      zIndex="sticky"
      shadow="0px -1px 0px 0px #EDF2F7 inset"
      bgColor="white"
    >
      <Link href="/" passHref prefetch={false}>
        <Flex
          as="a"
          title="File Uploader"
          justifyContent="flex-start"
          alignItems="center"
        >
          <HeadLogo />
        </Flex>
      </Link>
      <NoSsr>
        <ProfileNavbar />
      </NoSsr>
    </Flex>
  );
}

export { PageHeader };
